
import React, { useState, useEffect, useContext } from "react";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../../Routes/AuthProvider"
import { GetCities } from "../../Services/API"
import { RaiseCabEnquiry } from "../../Services/EnquiryApi"

const CabSearch = () => {
  const { name, userName, corporateId } = useContext(AuthContext);
  const [pickUpLocationSuggestions, setPickUpLocationSuggestions] = useState([]);
  const [dropLocationSuggestions, setDropLocationSuggestions] = useState([]);
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [enquiryMessage, setEnquiryMessage] = useState("");
  const [enquiryStatus, setEnquiryStatus] = useState(false);

  const [cabSearchParams, setCabSearchParams] = useState({
    travelType: "",
    pickUpLocation: "",
    dropLocation: "",
    fromDate: "",
    cabType: "Sedan",
  });

  const swapMainDestination = (e) => {
    e.preventDefault();

    setCabSearchParams((prev) => ({
      ...prev,
      pickUpLocation: prev.dropLocation,
      dropLocation: prev.pickUpLocation,
    }));
  };

  // FETCH PickUp SUGGESTIONS
  const handlePickUpLocation = async (e) => {
    const value = e.target.value;
    if (value.length > 2) {
      const data = await GetCities(value);
      setPickUpLocationSuggestions(data?.cities || []);
    } else {
      setPickUpLocationSuggestions([]);
    }
  };
  const [travelTypeMode, setTravelTypeMode] = useState("1");

  // FETCH DROP SUGGESTIONS
  const handleDropLocation = async (e) => {
    const value = e.target.value;
    if (value.length > 2) {
      const data = await GetCities(value);
      setDropLocationSuggestions(data?.cities || []);
    } else {
      setDropLocationSuggestions([]);
    }
  };

  // SELECT PICKUP CITY
  const selectPickUpLocation = (city) => {
    const location = `${city.cityName} - ${city.countryName}`;

    setCabSearchParams((prev) => ({
      ...prev,
      pickUpLocation: location,
    }));

    setPickUpLocationSuggestions([]);
  };

  // SELECT DROP CITY
  const selectDropLocation = (city) => {
    const location = `${city.cityName} - ${city.countryName}`;

    setCabSearchParams((prev) => ({
      ...prev,
      dropLocation: location,
    }));

    setDropLocationSuggestions([]);
  };

  // HANDLE INPUT CHANGES
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCabSearchParams((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    $("#departureDate").datepicker({
      dateFormat: "dd/mm/yy",
      appendTo: "#dateDisplay",
      minDate: 0,
      maxDate: "+4m",
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay").offset();
          const height = $("#dateDisplay").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },

      onSelect: function (StartDate) {
        const date = $(this).datepicker("getDate");
        const day = ("0" + date.getDate()).slice(-2);
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const dayName = date.toLocaleDateString("default", { weekday: "long" });

        $("#dep_dayNum").text(day);
        $("#dep_monthYear").text(`${month}-${year}`);
        $("#dep_dayName").text(dayName);

        setCabSearchParams(prev => ({
          ...prev,
          fromDate: StartDate
        }));
      },
    });
  }, []);

  useEffect(() => {
    $("#returnDate").datepicker({
      dateFormat: "dd/mm/yy",
      appendTo: "#dateDisplay2",
      minDate: 0,
      // minDate: function () {
      //   const start = $("#departureDate").datepicker("getDate");
      //   return start ? start : 0;
      // },
      maxDate: "+4m",
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay2").offset();
          const height = $("#dateDisplay2").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },
      onSelect: function (endDate) {
        const date = $(this).datepicker("getDate");
        const day = ("0" + date.getDate()).slice(-2);
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const dayName = date.toLocaleDateString("default", { weekday: "long" });

        $("#ret_dayNum").text(day);
        $("#ret_monthYear").text(`${month}-${year}`);
        $("#ret_dayName").text(dayName);

        setCabSearchParams(prev => ({
          ...prev,
          toDate: endDate
        }));

      },
    });
  }, []);

  const convertToDate = (str) => {
    if (!str) return null;
    const [day, month, year] = str.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  useEffect(() => {
    if (cabSearchParams.fromDate) {
      const minD = convertToDate(cabSearchParams.fromDate);
      $("#returnDate").datepicker("option", "minDate", minD);
    }
  }, [cabSearchParams.fromDate]);

  const times = [];
  for (let h = 0; h < 24; h++) {
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    const ampm = h < 12 ? "AM" : "PM";
    times.push(`${hour12.toString().padStart(2, "0")}:00 ${ampm}`);
  }

  const handleRaiseRequest = async () => {
    let newErrors = {};

    if (!cabSearchParams.pickUpLocation.trim()) {
      newErrors.pickUp = "Please select a pickUp location";
    }
    if (!cabSearchParams.dropLocation.trim()) {
      newErrors.drop = "Please select a Drop location";
    }
    if (!cabSearchParams.fromDate.trim()) {
      newErrors.fromdate = "Please select Trip Date";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
    //const userId = localStorage.getItem("selectedUserId");
    const userId = emulateCorporateCode || corporateId;
    const CorporateName = localStorage.getItem("selectedCorporateName");
    const requestBody = {
      TravelType: travelTypeMode,
      FromLocation: cabSearchParams.pickUpLocation,
      ToLocation: cabSearchParams.dropLocation,
      FromDate: cabSearchParams.fromDate, 
      ToDate: cabSearchParams.toDate || "",
      CabType: cabSearchParams.cabType,
      CompanyId: userId,
      OrganizationName: CorporateName,
      CreatedBy: userName
    };

    console.log("Request:", requestBody); //  DEBUG

    try {
      const result = await RaiseCabEnquiry(requestBody);

      console.log("Response:", result); //  DEBUG

      if (result?.success) {
        setEnquiryMessage(result.message);
        setEnquiryStatus(true);
      } else {
        setEnquiryMessage(result?.message || "Failed");
      }

      setShowPopup(true);

    } catch (err) {
      console.error("API ERROR:", err);  //  SEE THIS
      setEnquiryMessage("Server error. Please try again.");
      setShowPopup(true);
    }
  };
  return (
    <>
      <div className='cab_serch'>
        <div className='row'>
          <div className='col-md-6 col-lg-6'>
            <div className='d-flex'>
              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input className="form-check-input" type="radio" name="travelType" value="1"
                    checked={travelTypeMode === "1"}
                    onChange={(e) => {
                      setTravelTypeMode(e.target.value)
                    }}
                  />
                  <label className="form-check-label">Business Travel</label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input className="form-check-input" type="radio" name="travelType" value="2"
                    checked={travelTypeMode === "2"}
                    onChange={(e) => {
                      setTravelTypeMode(e.target.value)
                    }}
                  />
                  <label className="form-check-label">Personal Travel</label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input className="form-check-input" type="radio" name="travelType" value="3"
                    checked={travelTypeMode === "3"}
                    onChange={(e) => {
                      setTravelTypeMode(e.target.value)
                    }}
                  />
                  <label className="form-check-label">Guest Travel</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form_ful">
          {/* FROM */}
          <div className="s_col_cab">
            <div className="bus_icon_img">
              <img className="bus_ic" src="/assets/images/cab-blue.png" alt="bus" />
            </div>
            <div className="bus_icon">
              <p>Pick Up Location</p>
              <input
                type="text"
                className="pick_form"
                name="pickUpLocation"
                placeholder="Enter City.."
                value={cabSearchParams.pickUpLocation}
                onChange={(e) => {
                  handleChange(e);           // updates state
                  handlePickUpLocation(e);  // fetches suggestions
                }}
                autoComplete="off"
              />
              {pickUpLocationSuggestions.length > 0 && (
                <ul className="autosuggetsList">
                  {pickUpLocationSuggestions.map((city, index) => (
                    <li key={index} onClick={() => selectPickUpLocation(city)}>
                      {city.cityName} - {city.countryName}
                    </li>
                  ))}
                </ul>
              )}

              {errors.pickUp && <p className="error_mes">{errors.pickUp}</p>}


            </div>

            <a href="/" className="swiper_bus" onClick={swapMainDestination}>
              <img alt="icon" src="/assets/images/swipe.png" />
            </a>

          </div>

          {/* TO */}
          <div className="s_col_cab">
            <div className="bus_icon_img">
              <img className="bus_ic" src="/assets/images/cab-blue.png" alt="bus" />
            </div>

            <div className="bus_icon">
              <p>Drop Location</p>

              <input
                type="text"
                className="pick_form"
                name="dropLocation"
                placeholder="Enter City.."
                value={cabSearchParams.dropLocation}
                onChange={(e) => {
                  handleChange(e);           // updates state
                  handleDropLocation(e);  // fetches suggestions
                }}
                autoComplete="off"
              />
              {dropLocationSuggestions.length > 0 && (
                <ul className="autosuggetsList">
                  {dropLocationSuggestions.map((city, index) => (
                    <li key={index} onClick={() => selectDropLocation(city)}>
                      {city.cityName} - {city.countryName}
                    </li>
                  ))}
                </ul>
              )}
              {errors.drop && <p className="error_mes">{errors.drop}</p>}
            </div>


          </div>

          {/* DATE */}
          <div className="s_col_cab date_bssc">
            <div className="bus_icon_img">
              <img className="bus_ic" src="/assets/images/date.png" alt="date" />
            </div>

            <div className="bus_icon">
              <p>Date & Time</p>
              <div
                className="dest_nam"
                id="dateDisplay"
                onClick={() => $("#departureDate").datepicker("show")}
                style={{ cursor: "pointer" }}
              >
                <span id="dep_dayNum" style={{ fontSize: "28px", fontWeight: "bold" }}>
                  DD
                </span>{" "}
                <span id="dep_monthYear" style={{ fontSize: "14px" }}>
                  MM-YYYY
                </span>
                <br />
                <span id="dep_dayName">
                  DAY
                </span>
                <input
                  type="text"
                  id="departureDate"
                  style={{ position: "absolute", left: "-9999px" }}
                  readOnly
                />
              </div>
              {errors.fromdate && <p className="error_mes">{errors.fromdate}</p>}
            </div>
          </div>
          <div className="s_col_cab date_bssc">
            <div className="bus_icon_img">
              <img className="bus_ic" src="/assets/images/cab-blue.png" alt="date" />
            </div>

            <div className="bus_icon">
              <p>Cab Type</p>
              <select className='multi_selct'
                name="cabType"
                value={cabSearchParams.cabType}
                onChange={handleChange}
              >
                <option>Sedan</option>
                <option> MUV</option>
                <option> SUV </option>
                <option> Luxury </option>
              </select>

            </div>
          </div>

          {/* SEARCH BUTTON */}
          <div className="Rooms_Guests_Serch">
            <button className="Serch" onClick={handleRaiseRequest} type="button">
              Raise Request
            </button>

          </div>

        </div>


      </div>

      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <h3>{enquiryMessage}</h3>

            <button
              onClick={() => {
                setShowPopup(false);
                window.location.reload();
              }}
              className="btn btn-primary"
            >
              Ok
            </button>
          </div>
        </div>
      )}

    </>
  );
};

export default CabSearch;